import { render } from "./PasSupervisorQueue.vue?vue&type=template&id=3378784d&scoped=true"
import script from "./PasSupervisorQueue.vue?vue&type=script&lang=js"
export * from "./PasSupervisorQueue.vue?vue&type=script&lang=js"

import "./PasSupervisorQueue.vue?vue&type=style&index=0&id=3378784d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3378784d"]])

export default __exports__